import React, { FC } from 'react';

import {
    selectTotalPrice,
    selectTotalPriceMonth,
    selectTotalPriceWithOutSale,
} from '~/src/features/videocontrol/Provider/selectors';
import { useRequisitionContext } from '~/src/features/videocontrol/Provider/useRequisitionContext';

import * as ST from './styled';

export const TotalPoint: FC = ()=> {
    const { state } = useRequisitionContext();
    const totalPrice = selectTotalPrice(state);
    const totalPriceMonth = selectTotalPriceMonth(state);
    const totalPriceWithOutSale = selectTotalPriceWithOutSale(state);

    return (
        <ST.Container>
            <ST.ServiceWrap>
                <ST.Service>Ежемесячный платеж</ST.Service>
                <ST.PriceWrap>
                    <ST.Price data-test={'total-price-month'}>{totalPriceMonth} ₽/мес</ST.Price>
                </ST.PriceWrap>
            </ST.ServiceWrap>
            <ST.ServiceWrap>
                <ST.ServiceConnect>Итого при подключении:</ST.ServiceConnect>
                <ST.PriceWrap>
                    <ST.PriceConnect data-test={'total-price'}>
                        {totalPrice} ₽
                    </ST.PriceConnect>
                    {totalPrice !== totalPriceWithOutSale &&
                        <ST.OldPrice data-test={'price-without-sale'}>
                            {totalPriceWithOutSale} ₽
                        </ST.OldPrice>
                    }
                </ST.PriceWrap>
            </ST.ServiceWrap>
        </ST.Container>
    );
};
